import React from "react";
import { ResponsiveLine } from "@nivo/line";
import moment from "moment";

const dataMock = [
  {
    id: "Custo Distribuidora",
    color: "hsl(204, 100%, 50%)",
    data: [
      { x: "2024-09-01", y: 0 },
      // { x: "2023-02-01", y: 0 },
      // { x: "2023-03-01", y: 0 },
      // { x: "2023-04-01", y: 0 },
      // { x: "2023-05-01", y: 0 },
      // { x: "2023-06-01", y: 0 }
    ]
  },
  {
    id: "Custo BRZ",
    color: "hsl(160, 100%, 50%)",
    data: [
      { x: "2024-09-01", y: 0 },
      // { x: "2023-02-01", y: 0 },
      // { x: "2023-03-01", y: 0 },
      // { x: "2023-04-01", y: 0 },
      // { x: "2023-05-01", y: 0 },
      // { x: "2023-06-01", y: 0 }
    ]
  }
];

export default function DashboardConsorcioCompararEconomia({ data }) {

  return (
    <>
      {data !== null && data[0].data !== null ? (
        <div className="flex flex-col gap-3 bg-white h-full rounded-lg drop-shadow p-5">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
            <div>
              <h2 className="text-3xl font-bold text-gray-600">
                Comparar Economia
              </h2>
              <p className="text-base text-normal text-gray-500 mt-1">
                Valor da fatura em{" "}
                <span className="text-gray-600 font-medium">R$</span> a partir de maio/2024
                {/* últimos
                <span className="text-gray-600 font-medium"> 12 meses</span> */}
              </p>
            </div>
            <div className="flex items-center gap-7">
              <div className="flex gap-1.5 items-center">
                <div className="w-4 h-4 bg-blue-500 rounded" />
                <span className="text-sm text-gray-500 font-medium">
                  Custo Distribuidora
                </span>
              </div>
              <div className="flex gap-1.5 items-center">
                <div className="w-4 h-4 bg-teal-300 rounded" />
                <span className="text-sm text-gray-500 font-medium">
                  Custo BRZ
                </span>
              </div>
            </div>
          </div>
          <div className="w-full h-full min-h-[250px]">
            <ResponsiveLine
              data={data}
              margin={{ top: 0, right: 20, bottom: 28, left: 50 }}
              xScale={{ type: "point" }}
              yScale={{
                type: "linear",
                min: 0,
                max: "auto",
                stacked: false,
                reverse: false
              }}
              axisBottom={{
                format: function (value) {
                  return moment(value).format('MMM/YY');
                }
              }}
              axisTop={null}
              axisRight={null}
              curve="monotoneX"
              enableGridX={false}
              colors={["#2563eb", "#5eead4"]}
              colorBy="index"
              lineWidth={3}
              enableArea={true}
              enablePoints={false}
              motionStiffness={150}
              motionDamping={15}
              useMesh={true}
              background={{
                gradientFrom: "#171717",
                gradientTo: "#333333",
                color: "rgba(0,0,0,0)"
              }}
              tooltip={({ point }) => (
                <div
                  style={{
                    background: 'white',
                    padding: '5px',
                    border: '1px solid #ccc',
                    borderRadius: '3px',
                    color: 'black',
                  }}
                >
                  <strong>{moment(point.data.x).format('MMM/YY')}</strong>: {point.data.yFormatted}
                </div>
              )}
            />
          </div>
        </div>
      ) :
        (
          <div className="flex flex-col gap-3 bg-white h-full rounded-lg drop-shadow p-5">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
              <div>
                <h2 className="text-3xl font-bold text-gray-600">
                  Comparar Economia
                </h2>
                <p className="text-base text-normal text-gray-500 mt-1">
                  Valor da fatura em{" "}
                  <span className="text-gray-600 font-medium">R$</span> a partir de maio/2024
                </p>
              </div>
              <div className="flex items-center gap-7">
                <div className="flex gap-1.5 items-center">
                  <div className="w-4 h-4 bg-blue-500 rounded" />
                  <span className="text-sm text-gray-500 font-medium">
                    Custo Distribuidora
                  </span>
                </div>
                <div className="flex gap-1.5 items-center">
                  <div className="w-4 h-4 bg-teal-300 rounded" />
                  <span className="text-sm text-gray-500 font-medium">
                    Custo BRZ
                  </span>
                </div>
              </div>
            </div>
            <div className="w-full h-full min-h-[250px] z-10">
              <ResponsiveLine
                data={dataMock}
                margin={{ top: 0, right: 20, bottom: 28, left: 50 }}
                xScale={{ type: "point" }}
                yScale={{
                  type: "linear",
                  min: 0,
                  max: "auto",
                  stacked: false,
                  reverse: false
                }}
                axisBottom={{
                  format: function (value) {
                    return moment(value).format('MMM/YY');
                  }
                }}
                axisTop={null}
                axisRight={null}
                curve="monotoneX"
                enableGridX={false}
                colors={["#2563eb", "#5eead4"]}
                colorBy="index"
                lineWidth={3}
                enableArea={true}
                enablePoints={false}
                motionStiffness={150}
                motionDamping={15}
                useMesh={true}
                background={{
                  gradientFrom: "#171717",
                  gradientTo: "#333333",
                  color: "rgba(0,0,0,0)"
                }}
              />
            </div>
          </div>
        )}
    </>
  );
}
